<template>
    <app-layout-shell
        :sidebar-component="Sidebar"
        home-to="/workspace/tickets"
    ></app-layout-shell>
</template>

<script>
import {markRaw} from "vue";
import AppLayoutShell from "@/components/layout/shared/app-layout-shell";
import Sidebar from "@/components/layout/guest/sidebar";

export default {
    name: "guest-layout",
    components: {AppLayoutShell},
    data() {
        return {
            Sidebar: markRaw(Sidebar),
        };
    },
    metaInfo() {
        return {
            title: this.$store.state.settings.name,
            titleTemplate: () => this.$store.state.settings.name
        }
    },
}
</script>
